import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { SvgModule } from '@ui/svg/svg.module';
import { MainSidebarComponent } from './main-sidebar.component';
import { DirectivesModule } from '@shared/directives/directives.module';
import { PipesModule } from '@shared/pipes/pipes.module';

@NgModule({
  declarations: [MainSidebarComponent],
  exports: [MainSidebarComponent],
  imports: [CommonModule, RouterLink, RouterLinkActive, SvgModule, DirectivesModule, PipesModule],
})
export class MainSidebarModule {}
